import { logger } from '../../logger';
import { EXCLUSIVE_CATEGORIES } from './exclusiveGroups';

// Define category groups that can be considered complementary
const COMPLEMENTARY_CATEGORIES = {
  'Project Management': ['Task Management', 'Time Tracking', 'Collaboration'],
  'CRM': ['Marketing', 'Sales & CRM', 'Customer Support'],
  'Marketing': ['Social Media', 'Email Marketing', 'Analytics'],
  'Accounting': ['Payment Processing', 'Invoicing', 'Business Intelligence'],
  'Field Service': ['Scheduling', 'Payment Processing', 'Customer Support'],
  'Communication': ['Collaboration', 'Project Management', 'Customer Support']
} as const;

export function areSimilarCategories(category1: string, category2: string): boolean {
  const cat1 = category1.toLowerCase();
  const cat2 = category2.toLowerCase();

  // Direct match
  if (cat1 === cat2) {
    logger.debug('Direct category match', { category1, category2 });
    return true;
  }

  // Check exclusive category groups
  for (const [groupName, categories] of Object.entries(EXCLUSIVE_CATEGORIES)) {
    const lowerCategories = categories.map(c => c.toLowerCase());
    if (lowerCategories.includes(cat1) && lowerCategories.includes(cat2)) {
      logger.debug('Categories in same exclusive group', {
        group: groupName,
        categories: [category1, category2]
      });
      return true;
    }
  }

  // Check for partial matches
  if (cat1.includes(cat2) || cat2.includes(cat1)) {
    logger.debug('Partial category match', { category1, category2 });
    return true;
  }

  return false;
}

export function areComplementaryCategories(category1: string, category2: string): boolean {
  const cat1 = category1.toLowerCase();
  const cat2 = category2.toLowerCase();

  for (const [mainCategory, complementary] of Object.entries(COMPLEMENTARY_CATEGORIES)) {
    const mainCat = mainCategory.toLowerCase();
    const complementaryLower = complementary.map(c => c.toLowerCase());
    
    // Check if categories are in complementary relationship
    if ((cat1 === mainCat && complementaryLower.includes(cat2)) ||
        (cat2 === mainCat && complementaryLower.includes(cat1))) {
      return true;
    }
  }

  return false;
}